import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '@/views/Login.vue'


const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/attendance',
    name: 'Attendance',
    component: () => import("@/views/attendance01.vue")
  },
  {
    path: '/attendGroup',
    component: () => import("@/views/attendGroup.vue")
  },
  {
    path: '/attendClasses',
    component: () => import("@/views/attendClasses.vue")
  },
  {
    path: '/attendAddress',
    component: () => import("@/views/attendAddress.vue")
  },
  {
    name: 'attendScheduling',
    path: '/attendScheduling',
    component: () => import("@/views/attendScheduling.vue")
  },
  {
    path: '/attendReCard',
    component: () => import("@/views/attendReCard.vue")
  },
  {
    path: '/attendHoliday',
    component: () => import("@/views/attendHoliday.vue")
  },
  {
    path: '/notClockIn',
    component: () => import("@/views/notClockIn.vue")
  },
  {
    path: '/employee',
    component: () => import("@/views/Employee.vue")
  },
  {
    path: '/attendLeave',
    component: () => import("@/views/AttendLeave.vue")
  },
  {
    path: '/attendConfirm',
    component: () => import("@/views/AttendConfirm.vue")
  },
  {
    path: '/attendAudit',
    component: () => import("@/views/audit/attendAudit.vue"),
    children: [
      {
        path: '/audit',
        name: 'Audit',
        component: () => import('@/views/audit/Audit.vue'),
      },
      {
        path: '/audit-record',
        name: 'AuditRecord',
        component: () => import('@/views/audit/AuditRecord.vue'),
        children: [
          {
            path: '/shift-change',
            name: 'ShiftChangeRecord',
            component: () => import('@/views/audit/record/ShiftChangeRecord.vue'),
          },
          {
            path: '/card-replacement',
            name: 'CardReplacementRecord',
            component: () => import('@/views/audit/record/CardReplacementRecord.vue'),
          }
        ]
      },
    ]
  }

]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 导航守卫
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token');
//   if (!token && to.path !== '/') {
//     next({ name: 'Login' });
//   } else if (token && to.path === '/') {
//     next({ name: 'Attendance' }); // 或者你想跳转到的默认页面
//   } else {
//     next();
//   }
// });
export default router
